import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { Erc20Contract, Erc20Section, IndexWrapper, ServiceType } from "@framework/shared";

export const erc20Routes: Array<RouteObject> = [
  {
    path: "/erc20",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="erc20">
            <Erc20Section />
          </IndexWrapper>
        ),
      },
      {
        path: "/erc20/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <Erc20Contract service={ServiceType.ADMIN} /> },
          { path: "/erc20/contracts/:id/:action", element: <Erc20Contract service={ServiceType.ADMIN} /> },
        ],
      },
    ],
  },
];
